const ukUA = {
    crossmintPayButtonService: {
        CONNECTING: "Підключення...",
        BUY: "Купити за допомогою Crossmint",
        BUY_WITH_ETH: "Купити за ETH",
        BUY_WITH_SOL: "Купити за SOL",
        BUY_WITH_CREDIT_CARD: "Купити за допомогою кредитної картки",
    },
};
export default ukUA;
